import React from 'react';
import { useEffect, useState } from 'react';
import Text from '../../Base/Text/Text';
import { joinClasses } from '../../../Utils/className.util';
import { useAppContext } from '../../../Services/AppContext';

// @ts-ignore
import styles from './Collapse.module.scss';

interface CollapseProps {
	children?: any;
	title?: string;
	className?: string;
	headerClassName?: string;
	contentClassName?: string;
	defaultOpen?: boolean;
	contentPadding?: boolean;
	icon?: string;
	onOpen?: () => void;
	onClose?: () => void;
}

export default function Collapse(props: CollapseProps) {
	const {
		title,
		children,
		className,
		defaultOpen = false,
		contentPadding = false,
		contentClassName,
		icon,
		headerClassName,
		onOpen,
		onClose,
	} = props;
	const [collapsed, setCollapsed] = useState(defaultOpen);
	const { translation } = useAppContext();

	useEffect(() => {
		setCollapsed(defaultOpen);
	}, [defaultOpen]);

	const handleToggleCollapse = () => {
		if (!collapsed) {
			onOpen?.();
		} else {
			onClose?.();
		}
		setCollapsed(prevValue => !prevValue);
	};

	return (
		<div className={joinClasses([styles.wrapper, className])}>
			<div
				className={joinClasses([styles.header, headerClassName])}
				onClick={handleToggleCollapse}>
				<div className={styles.titleWrapper}>
					{icon && <img className={styles.icon} src={icon} />}
					{title && <Text tx={title} className={styles.title} firstUpper />}
				</div>
				<div className={collapsed ? styles.buttonHide : styles.buttonShow}>
					{collapsed
						? translation['base.hide']
						: translation['base.shared.show']}
				</div>
			</div>
			{collapsed && (
				<div
					className={joinClasses([
						styles.content,
						contentPadding && styles.contentPadding,
						contentClassName,
					])}>
					{children}
				</div>
			)}
		</div>
	);
}
